<template>
  <div id="app">
    <!-- 请求接口loading -->
    <loading />
    <keep-alive> 
      <router-view  v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
  </div>
</template>
<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import loading from '@/components/loading/loading.vue'
  export default {
    computed: {

    },
    created() {
      console.log('1111');
      this.getAccessToken()
      // 初始化微信分享
      this.wxShareInit()
    },
    mounted() {
      // 埋点代码
      const script = document.createElement("script"); // 学习考试前端友盟脚本
      script.src = "https://v1.cnzz.com/z_stat.php?id=1279915578&web_id=1279915578";
      // script.src = "./assets/lib/js/z_stat.js";
      script.language = "javascript";
      document.body.appendChild(script);
      this.wxShareInit()
    },
    methods: {
      ...mapActions(['getAccessToken']),
      // 友盟埋点方法
      cnzzStat(category, action, label, value, nodeid) {
      // category：事件类别，必填项，表示事件发生在谁身上，如“视频”、“小说”、“轮显层”等等。
      // action：事件操作，必填项，表示访客跟元素交互的行为动作，如"播放"、"收藏"、"翻层"等等。
      // label：事件标签，选填项，用于更详细的描述事件，从各个方面都可以，比如具体是哪个视频，哪部小说，翻到了第几层等等。
      // value：事件值，选填项，整数型，用于填写打分型事件的分值，加载时间型事件的时长，订单型事件的价格等等。
      // nodeid：div元素id，选填项，填写网页中的div元素id值，用于在“用户视点”功能上重绘元素的事件发生情况。
      if (category && action) {
        window._czc(["_trackEvent", category, action, label, value, nodeid]);
      } else {
        console.warn("未传入埋点事件类别和操作");
      }
    },
      // 获取微信分享票据
      getWXShare () {
        const params = {
          data: {
            shareUrl: 'https%3A%2F%2Fdemo.gkgzj.com%2Fmanager-intf%2F'
          }
        }
        this.$http.getShareTicket(params)
          .then(res => {
            console.log(res)
          })
      },
      // 微信分享
      wxShareInit() {
        setTimeout(() => {
          console.log('首页已改分享666');
           this.initShare()
        }, 400);
        // let descs = '因为爱, 所以感控';
        // let taskName = '快速了解感控工作间';
        // console.log('666走....');
        // this.commom.weiXinReady(2, descs, taskName, "", "", "", () => {
        //   this.isShare = false;
        // });
      },
    },
    data() {
      return {
        tokenInterval: null
      }
    },
    beforeDestroy() {
      console.log('destory');
    },
    name: 'App',
    components: {
      loading,
    },
  }
</script>
<style lang="scss">
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    div::-webkit-scrollbar {
     display: none; /* Chrome Safari */
     scrollbar-width: none; /* firefox */
     -ms-overflow-style: none; /* IE 10+ */
    }
  }
</style>
